'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_TimePickerProps = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _inputGroup = require('../../input-group');

var _inputGroup2 = _interopRequireDefault(_inputGroup);

var _select = require('../../select');

var _select2 = _interopRequireDefault(_select);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var cx = _bind2.default.bind(_style2.default);

var bpfrpt_proptype_TimePickerProps = {
  disabledMinutes: _propTypes2.default.bool
};

var TimePicker = function (_PureComponent) {
  _inherits(TimePicker, _PureComponent);

  function TimePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.getCurrentHours = function (date) {
      return date ? date.getHours() : 12;
    }, _this.getCurrentMinutes = function (date) {
      return date ? date.getMinutes() : 0;
    }, _this.hours = new Array(24).fill().map(function (v, index) {
      return {
        label: index.toLocaleString('en-US', {
          minimumIntegerDigits: 2
        }),
        value: index
      };
    }), _this.minutes = new Array(60).fill().map(function (v, index) {
      return {
        label: index.toLocaleString('en-US', {
          minimumIntegerDigits: 2
        }),
        value: index
      };
    }), _this.handleChange = function (type, value) {
      var currentDate = _this.props.value || new Date();

      _this.props.onChange(new Date(currentDate.setMilliseconds(1)));

      if (type === 'hours') {
        setTimeout(function () {
          _this.props.onChange(new Date(currentDate.setHours(value)));
        });
      } else {
        setTimeout(function () {
          _this.props.onChange(new Date(currentDate.setMinutes(value)));
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimePicker, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: cx('xsui-datepicker-timepicker')
      }, _react2.default.createElement(_inputGroup2.default, {
        appearance: 'two-dots'
      }, _react2.default.createElement(_select2.default, {
        input: {
          name: 'time',
          value: this.getCurrentHours(this.props.value),
          onChange: this.handleChange.bind(this, 'hours')
        },
        options: this.hours,
        size: 'sm',
        disabled: this.props.disabled,
        disabledLimitationMinWidth: true,
        style: {
          width: 80
        }
      }), _react2.default.createElement(_select2.default, {
        input: {
          name: 'time',
          value: this.getCurrentMinutes(this.props.value),
          onChange: this.handleChange.bind(this, 'minutes')
        },
        options: this.minutes,
        size: 'sm',
        disabled: this.props.disabled || this.props.disabledMinutes,
        disabledLimitationMinWidth: true,
        style: {
          width: 80
        }
      })));
    }
  }]);

  return TimePicker;
}(_react.PureComponent);

TimePicker.propTypes = {
  disabledMinutes: _propTypes2.default.bool,
  value: function value(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  onChange: _propTypes2.default.func.isRequired,
  disabled: _propTypes2.default.bool
};
exports.default = TimePicker;
exports.bpfrpt_proptype_TimePickerProps = bpfrpt_proptype_TimePickerProps;